/**
 * Safely calls element.matches() with a guard against environments or mocked
 * elements where matches is not a function.
 */
export function matches(element: Element, selector: string): boolean {
  return typeof element.matches === 'function' && element.matches(selector);
}
